import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes/routes";
import { SnackbarProvider } from "notistack";
import Slide from "@mui/material/Slide";
import ThemeSupplier from "./theme/ThemeSupplier";
import { NewPatientContextProvider } from "./store/NewPatientContextProvider";
import { AuthUserContextProvider } from "./store/AuthUserContextProvider";
import { DataListsContextProvider } from "./store/DataListsContextProvider";
import "./index.css";
import "../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

ReactDOM.render(
  <React.StrictMode>
    <SnackbarProvider
      maxSnack={3}
      preventDuplicate
      autoHideDuration={4500}
      TransitionComponent={Slide}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <AuthUserContextProvider>
        <DataListsContextProvider>
          <NewPatientContextProvider>
            <ThemeSupplier>
              <Routes />
            </ThemeSupplier>
          </NewPatientContextProvider>
        </DataListsContextProvider>
      </AuthUserContextProvider>
    </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
